module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-loading-wrapper"
  }, [_c('el-card', [_c('div', {
    staticClass: "img-loading"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 320,
      "height": 320,
      "primary": "#E6EBF5",
      "secondary": "#D8DCE5"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "24",
      "rx": "4",
      "ry": "4",
      "width": "100%",
      "height": "100%"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "info-loading"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 320,
      "height": 120,
      "primary": "#E6EBF5",
      "secondary": "#D8DCE5"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "50",
      "rx": "0",
      "ry": "0",
      "width": "100%",
      "height": "100%"
    }
  })])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55318598","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardItemLoading.vue
// module id = 1181
// module chunks = 23